export default __webpack_public_path__ + "static/media/abhijeet.ee23d5a4.jpg";